import React from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'react-bootstrap'
import DocumentTitle from "react-document-title"

import UserTasks from '../tasks/UserTasks.jsx'
import UserTripsList from '../trips/UserTrips.jsx'

import Calendar from '../dashboard/Calendar'

import { getText } from '../lib/text.js'
import "./Home.less"

const rowStyle = { margin: "20px", maxWidth: 1100 }

type HomeProps = {
  username: string
}

const Home = ({ username }: HomeProps) => (
  <div className="home-page">

    <DocumentTitle title= {`Tripmaker ${getText("Home")}`} />
    <Row style={rowStyle}>
      <Col md={5}>
        <UserTripsList username={username} />
      </Col>
      <Col md={7}>
        <UserTasks username={username} />
      </Col>
    </Row>

    <Calendar />
  </div>
)

export default connect(
  state => ({  
    username: state.loginData && state.loginData.username
  })
)(Home)
